import type { FC } from "react";
import { clsx } from "clsx";

type CircularProgressBarProps = {
  progressPercentage: number;
  className?: string;
  sizeClasses?: string;
  progressColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
  radius?: number;
  animated?: boolean;
}

export const CircularProgressBar: FC<CircularProgressBarProps> = ({
  progressPercentage,
  className = "",
  sizeClasses = "w-8 h-8",
  progressColor = "text-gray-800",
  backgroundColor = "text-gray-800/10",
  strokeWidth = 3,
  radius = 14,
  animated = true,
}) => {
  const normalizedRadius = radius - strokeWidth * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progressPercentage / 100) * circumference;

  return (
    <>
      <div className={clsx(sizeClasses, "relative")}>
        <svg
          viewBox={`0 0 ${radius * 2} ${radius * 2}`}
          className={clsx(className, sizeClasses, backgroundColor, "absolute")}>
          <circle
            stroke="currentColor"
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={`${circumference} ${circumference}`}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        <svg
          viewBox={`0 0 ${radius * 2} ${radius * 2}`}
          className={clsx(className, sizeClasses, progressColor, "absolute")}>
          <circle
            stroke="currentColor"
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={`${circumference} ${circumference}`}
            style={{
              strokeDashoffset: strokeDashoffset <= 0 ? 0 : strokeDashoffset,
            }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            strokeLinecap="round"
            className={clsx(animated ? "transition-all" : "")}
          />
        </svg>
      </div>
    </>
  );
};
